export const style = {
  h2: {
    fontSize: `32px`,
    fontWeight: 300,
    color: `black`,
    margin: `0 0 32px 0`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Community/Settings/Main/style/headers.js